import DropdownUser from './DropdownUser';
import {useNavigate, useSearchParams, useLocation} from "react-router-dom";
import {useForm} from "react-hook-form";
import {Form} from "react-bootstrap";
import React, {useEffect, useState} from "react";

const Header = (props) => {
  const [hasClearButton, setHasClearButton] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    register,
    handleSubmit,
    setValue,
  } = useForm({})

  useEffect(() => {
    const query = searchParams.get('query');

    if (query !== null && query !== "") {
      setValue('query', query)
      setHasClearButton(true)
    }
  }, [searchParams, setValue]);

  const onsubmit = ({query}) => {
    setSearchParams(searchParams => {
      if (query !== "") {
        searchParams.set('query', query);
        setHasClearButton(true)
      } else {
        searchParams.delete('query')
        setHasClearButton(false)
      }

      return searchParams;
    });

    if (query !== "" && location.pathname !== '/tiers-payant') {
      navigate(`/tiers-payant?query=${query}`)
    }
  }

  const clearQuery = () => {
    setSearchParams(searchParams => {
      searchParams.delete('query')
      setHasClearButton(false)

      return searchParams;
    });
    setValue('query', "")
  }

  return (
      <nav className="navbar navbar-expand navbar-light navbar-bg sticky-top">
        <button
            className="sidebar-toggle"
            onClick={(e) => {
              e.stopPropagation();
              props.setSidebarOpen(!props.sidebarOpen);
            }}
        >
          <i className="hamburger align-self-center"></i>
        </button>

        <Form onSubmit={handleSubmit(onsubmit)}>
          <div className="input-group input-group-navbar">
            <Form.Control
                type="text"
                placeholder="Recherche factures TP…"
                size="lg"
                {...register("query")}
            />
            {hasClearButton && <button className="btn" type="button" onClick={() => clearQuery()}>
              <i className="fa-solid fa-xmark"></i>
            </button>}
            <button className="btn" type="submit">
              <i className="fa-solid fa-magnifying-glass"></i>
            </button>
          </div>
        </Form>

        <div className="navbar-collapse collapse">
          <ul className="navbar-nav navbar-align">
            <DropdownUser />
          </ul>
        </div>
      </nav>
)
};

export default Header;
